import { useQuery } from "@tanstack/react-query";
import { fetchGetLatestTemplateRiderComponent, fetchTemplateRiderComp } from "../../../utils/apiUtils";
import FormSelect from "../../shared/FormSelect";
import { SLOT_NAMES } from "../../../utils/constants";

const step = 3

const StepThree = ({ activeStep, control, errors, getValues }) => {
    if (activeStep !== step) return

    const template = getValues("template")
    const account = getValues("account")

    const { data: bankAccountOptions } = useQuery({
        queryKey: ['getBankAccounts'],
        // queryFn: async () => await fetchTemplateRiderComp({
        //     category: SLOT_NAMES.BANK_ACCOUNT,
        //     //  bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
        //     searchText: account?.label?.split(' ')?.[0],
        // }),
        // select: (data) => data.hits.hits.map(({ _source: { metadata } }, i) => ({
        //     value: metadata.benefitPlanRiderHccId,
        //     label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //     additional: metadata,
        // })),
        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.BANK_ACCOUNT,
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            searchText: account?.label?.split(' ')?.[0],
            limit: 100
        }),
        select: (data) => data.rows.map((metadata, i) => ({
            value: metadata.benefitPlanRiderHccId,
            label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: metadata,
        })),
        enabled: !!template?.additional?.benefitPlanTemplateKey,
    })

    const { data: memberUdtOptions } = useQuery({
        queryKey: ['memberUdtOptions'],
        // queryFn: async () => await fetchTemplateRiderComp({
        //     category: SLOT_NAMES.MEMBER_UDT,
        //     // bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey
        // }),
        // select: (data) => data.hits.hits.map(({ _source: { metadata } }, i) => ({
        //     value: metadata.benefitPlanRiderHccId,
        //     label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //     additional: metadata,
        // })),
        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.MEMBER_UDT,
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => data.rows.map((metadata, i) => ({
            value: metadata.benefitPlanRiderHccId,
            label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: metadata,
        })),
        enabled: !!template?.additional?.benefitPlanTemplateKey,
    })

    const { data: valueListOptions } = useQuery({
        queryKey: ['getValueList'],
        // queryFn: async () => await fetchTemplateRiderComp({
        //     category: 'Value List',
        //     searchText: account?.label,
        //     //  bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey
        // }),
        // select: (data) => data.hits.hits.map(({ _source: { metadata } }, i) => ({
        //     value: metadata.benefitPlanRiderHccId,
        //     label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //     additional: metadata,
        // })),
        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            benefitPlanRiderTypeName: 'Value List',
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            searchText: account?.label?.split(' ')?.[0],
            limit: 100
        }),
        select: (data) => data.rows.map((metadata, i) => ({
            value: metadata.benefitPlanRiderHccId,
            label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: metadata,
        })),
        enabled: !!template?.additional?.benefitPlanTemplateKey,
    })

    const { data: cobOptions } = useQuery({
        queryKey: ['getDefaultCob'],
        queryFn: async () => {
            const results = await fetchTemplateRiderComp({
                //  category: 'Benefits - Standard Exclusions',
                searchText: 'COB - Standard Calculation Method',
                //  bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
                benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey
            });
            return results
        },
        select: (data) => data.hits.hits
            .map(hit => hit._source.metadata)
            .filter((metadata) => !metadata.benefitPlanRiderHccId)
            .map((metadata, i) => ({
                value: metadata.benefitPlanCompName,
                label: `${metadata.benefitPlanCompName}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
                additional: metadata,
            })),
        enabled: !!template?.additional?.benefitPlanTemplateKey
    })

    const { data: cobRiderOptions } = useQuery({
        queryKey: ['getRiderCob'],
        // queryFn: async () => await fetchTemplateRiderComp({
        //     category: SLOT_NAMES.COB_PROCESSING,
        //     // bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey
        // }),
        // select: (data) => data.hits.hits
        //     .map(hit => hit._source.metadata)
        //     .filter((metadata) => !!metadata.benefitPlanRiderHccId)
        //     .map((metadata, i) => ({
        //         value: metadata.benefitPlanRiderHccId,
        //         label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //         additional: metadata,
        //     })),

        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.COB_PROCESSING,
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => data.rows.map((metadata, i) => ({
            value: metadata.benefitPlanRiderHccId,
            label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: metadata,
        })),

        enabled: !!template?.additional?.benefitPlanTemplateKey,
    })

    return (
        <>
            <FormSelect
                label={"Member UDT's"}
                name={'memberUdt'}
                control={control}
                options={memberUdtOptions}
                errors={errors}
                placeholder="Select a product"
            />

            <FormSelect
                label={'Bank Account'}
                name={'bankAccount'}
                control={control}
                options={bankAccountOptions}
                errors={errors}
                placeholder="Select..."
                disabled={false}
            />

            <p style={{ fontWeight: 600, fontSize: '1.2rem', padding: '1rem 0rem' }}>Value List</p>
            <FormSelect
                label={'Default from template'}
                name={'defaultValueListByTemplate'}
                control={control}
                options={[]}
                errors={errors}
                placeholder="Select..."
                disabled={true}
            />

            <FormSelect
                label={'Overwrite Value List'}
                name={'valueList'}
                control={control}
                options={valueListOptions}
                errors={errors}
                placeholder="Select..."
                disabled={false}
            />

            <p style={{ fontWeight: 600, fontSize: '1.2rem', padding: '1rem 0rem' }}>COB</p>

            <FormSelect
                label={'Default'}
                name={'cob.default'}
                control={control}
                options={cobOptions}
                errors={errors}
                placeholder="Select..."
                disabled={true}
            />

            <FormSelect
                label={'Overwrite COB'}
                name={'cob.overwrite'}
                control={control}
                options={cobRiderOptions}
                errors={errors}
                placeholder="Select..."
            />
        </>
    )
}

export default StepThree
